export default "__VITE_ASSET__DZw6uunL__"